import {Component, Input} from '@angular/core';
import {TileType21} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-additional-pump',
    templateUrl: './tile-additional-pump.component.html',
    styleUrls: ['./tile-additional-pump.component.scss']
})
export class TileAdditionalPumpComponent {
    @Input() tile: TileType21;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
